import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['count']
  private previousCount = 0

  // turbo_stream で件数要素が差し替わるたびに、前回件数から新値へカウントアップする
  countTargetConnected(element: HTMLElement): void {
    const next = Number(element.textContent) || 0
    this.animateCount(element, this.previousCount, next)
    this.previousCount = next
  }

  // NOTE: 今のカウントから新しいカウントまで300msでパラパラ漫画のようにカウントアップする
  private animateCount(element: HTMLElement, from: number, to: number): void {
    if (from === to) return

    const duration = 300
    const start = performance.now()
    const step = (now: number): void => {
      const progress = Math.min((now - start) / duration, 1)
      element.textContent = String(Math.round(from + (to - from) * progress))
      if (progress < 1) requestAnimationFrame(step)
    }
    requestAnimationFrame(step)
  }
}
